'use strict';/* global define, console */define('modules/users/directives/notifications/controller',['require','exports','module','angular'],function(require,exports,module){'use strict';
     controller.$inject = ["$scope", "$timeout", "Notifications", "Toaster", "Modals"];var ng=require('angular');// @ngInject
function controller($scope,$timeout,Notifications,Toaster,Modals){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.userId=$scope.userId;ctrl.notifications=Notifications.get({userId:ctrl.userId});ctrl.values=[{value:true,key:'NOTIFICATION.SETTING.YES'},{value:false,key:'NOTIFICATION.SETTING.NO'}];ctrl.notifications.$promise.then(function(notifications){// clone it so that we do not
// share the reference
ctrl.notificationsClone=ng.copy(notifications);$scope.$emit('$viewContentLoaded');}).catch(Modals.fail).finally(function(){ctrl.busy=false;});ctrl.busy=true;ctrl.changed=false;ctrl.cancel=cancel;ctrl.handleChange=handleChange;ctrl.handleToggleKeyup=handleToggleKeyup;ctrl.submit=submit;// ---
/**
     * Cancel all modification to notifications
     * and set back the original state
     *
     * @tested
     */function cancel(){// copy again to provide functionality
// of multiple cancel actions
ctrl.notifications=deepExtend(ctrl.notifications,ctrl.notificationsClone);ctrl.changed=false;}/**
     * Helper function to deep extend
     * the notifications
     *
     * ```
     * ctrl.notifications = deepExtend(
     *   ctrl.notifications,
     *   ctrl.notificationsClone
     * );
     * ```
     *
     * @param  {Object} dst - Destination object
     * @param  {Object} add - destination
     *
     * @return {Object}     extended object
     */function deepExtend(dst){ng.forEach(arguments,function(obj){if(obj!==dst){ng.forEach(obj,function(value,key){if(dst[key]&&dst[key].constructor&&(dst[key].constructor===Object||dst[key].constructor===Array)){deepExtend(dst[key],value);}else{dst[key]=value;}});}});return dst;}/**
     * Handle the change event of the form
     * to enable form submit UI wise
     *
     * @tested
     */function handleChange(){ctrl.changed=true;}/**
     * Make the custom toggle accessible! :)
     *
     * @param  {Object} event event
     */function handleToggleKeyup(event){if(event.keyCode===13||event.keyCode===32){event.preventDefault();$timeout(function(){var checkbox=event.target.querySelector('input');checkbox.click();event.target.setAttribute('aria-checked',checkbox.checked);});}}/**
     * Push the updated notifications to
     * the server baby
     *
     * @param  {String} successKey success message to be shown in toaster
     *
     * @tested
     */function submit(successKey){ctrl.busy=true;Notifications.update({userId:ctrl.userId},ctrl.notifications).$promise.then(function(){ctrl.notificationsClone=ng.copy(ctrl.notifications);Toaster.success(successKey);}).catch(function(response){Toaster.error(response.data.message);ctrl.cancel();}).finally(function(){ctrl.busy=false;ctrl.changed=false;});}}module.exports=controller;});
